import {
  CREATE_WIZARD_SUBTITLE,
  createWizardTitle,
} from '@internal/plugin-waadoo-core';

/**
 * The wizard's title and subtitle, apart from the wizard itself: the « Créer »
 * page (createPage/CreatePage.tsx) shows them as its header on the wizard's
 * route, and must not pull the lazily loaded wizard into its own chunk to
 * do so. The words are the core's, shared with the generic wizard.
 */
export const WIZARD_TITLE = createWizardTitle('Odoo');
export const WIZARD_SUBTITLE = CREATE_WIZARD_SUBTITLE;
